module.exports = __webpack_public_path__ + "static/media/accessibility2.5b0efe86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/accessibility2.svg
// module id = 2245
// module chunks = 7